/**
 * Dev/staging console errors for invalid experiment config.
 *
 * `NODE_ENV` is compile-time inlined in product bundles, so staging (`*.jira-dev.com`,
 * `*.stg.atlassian.com`, `*.stg-<location>.frontend.public.atl-paas.net`) is production as far
 * as that check is concerned. Hostname is the runtime signal message makers will actually see.
 *
 * `prod-<location>.frontend.public.atl-paas.net` is production and must not match.
 *
 * Hostname is read from `globalThis.location` so SSR without a location polyfill is a no-op.
 */
const STAGING_HOSTNAME_PATTERN =
	/(?:^|\.)(?:jira-dev\.com|stg(?:\.internal)?\.atlassian\.com|stg-[a-z0-9]+\.frontend\.public\.atl-paas\.net)$/;

const readHostname = (): string | undefined => {
	try {
		const hostname = globalThis.location?.hostname;
		return typeof hostname === 'string' && hostname.length > 0 ? hostname : undefined;
	} catch {
		return undefined;
	}
};

export const shouldLogDevError = (): boolean => {
	if (process.env.NODE_ENV !== 'production') {
		return true;
	}

	const hostname = readHostname();
	return hostname !== undefined && STAGING_HOSTNAME_PATTERN.test(hostname);
};

export const logDevError = (message: string): void => {
	if (shouldLogDevError()) {
		// eslint-disable-next-line no-console
		console.error(message);
	}
};
